import {
  createDecisionRecommendation,
  DECISION_ENGINES,
  DECISION_SCOPES,
} from "../models";

export function scenarioRecommendationAdapter(scenarioDecision) {
  const executiveReport = scenarioDecision?.executive_report;
  const recommendation =
    scenarioDecision?.decision_recommendation ??
    scenarioDecision?.recommendation ??
    executiveReport?.recommended_strategy ??
    null;

  if (!recommendation || typeof recommendation !== "object") {
    return [];
  }

  return [createDecisionRecommendation({
    id:
      recommendation.id ??
      recommendation.strategy_id ??
      scenarioDecision.id ??
      executiveReport?.scenario?.id ??
      null,
    source: "scenario_decision",
    engine: DECISION_ENGINES.SCENARIO,
    scope: DECISION_SCOPES.SCENARIO,
    decisionType:
      recommendation.decisionType ??
      recommendation.decision_type ??
      recommendation.recommendation_type ??
      null,
    title:
      recommendation.title ??
      executiveReport?.scenario?.name ??
      "Scenario Decision",
    strategy:
      recommendation.strategy ??
      recommendation.strategy_name ??
      null,
    rationale:
      recommendation.rationale ??
      executiveReport?.decision_rationale ??
      null,
    priority: recommendation.priority ?? null,
    financialImpact:
      recommendation.financialImpact ??
      recommendation.financial_impact ??
      (executiveReport ? {
        fundingRequirement: recommendation.funding_requirement ?? null,
        capitalCommitted: recommendation.capital_committed ?? null,
        economicCost: recommendation.economic_cost ?? null,
        fundingGap: recommendation.funding_gap ?? null,
      } : null) ??
      null,
    evidence:
      recommendation.evidence ??
      (executiveReport ? {
        currentPosition: executiveReport.current_position ?? null,
        selectedPosition: executiveReport.selected_position ?? null,
        alternative: executiveReport.alternative ?? null,
      } : null),
    metadata: {
      ...(recommendation.metadata || {}),
      sourceRecommendation: recommendation,
      businessQuestion:
        recommendation.businessQuestion ?? recommendation.business_question ??
        executiveReport?.businessQuestion ?? executiveReport?.business_question ?? null,
      decisionRequired:
        recommendation.decisionRequired ?? recommendation.decision_required ??
        executiveReport?.decisionRequired ?? executiveReport?.decision_required ?? null,
      recommendedAlternative:
        recommendation.recommendedAlternative ?? recommendation.recommended_alternative ??
        recommendation.strategy ?? recommendation.strategy_name ?? null,
      sourceReference:
        recommendation.sourceReference ?? recommendation.source_reference ??
        executiveReport?.sourceReference ?? executiveReport?.source_reference ?? null,
    },
  })];
}

export default scenarioRecommendationAdapter;
